import BattleshipChangeDto from '../../models/battleship/battleshipChange';
import BattleshipMove from '../../models/battleship/battleshipMove';

export const BattleshipApiMapper = {
    mapBattleshipMovesToBattleshipChangeDtos(battleshipMoves: Array<BattleshipMove>): Array<BattleshipChangeDto> {
        let output: Array<BattleshipChangeDto> = [];

        if (!battleshipMoves.length) return output;

        battleshipMoves.forEach((m) => {
            const moveChanges = m.timetableFunctions.map((f) => new BattleshipChangeDto(m.changeIndex, f.functionId, m.weekDayId, m.timeIn, m.roomId, f.instructorId));

            output = [...output, ...moveChanges];
        });

        return output;
    },
};
